import { Component, OnInit } from '@angular/core';
import { Filosofia_Corporativa, Instituciones, Planificacion, procesamiento, obtenerError } from '../../../models/Formulacion/indicadores-metas/datos';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { DataService } from '../../../services/data/data.service';
import { ExcelService } from '../../../services/excel/excel.service';
import { FilosofiaCorporativaService } from '../../../services/formulacion/filosofiaCorporativa/filosofia-corporativa.service';
import Swal from 'sweetalert2';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom } from 'rxjs';
import { messages } from '../../funciones/mensajes';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

import { PlanificacionService } from '../../../services/gestion/planificacion/planificacion.service';
import { FilosofiaService } from '../../../services/gestion/filosofia/filosofia.service';
import { PERMISOS } from '../../../shared/catalogos';

@Component({
  selector: 'app-filosofiacorporativa',
  templateUrl: './filosofiacorporativa.component.html',
  styleUrl: './filosofiacorporativa.component.css'
})
export class FilosofiacorporativaComponent implements OnInit {
  public readonly permisos = PERMISOS;

  private planeacionNombre: string;
  public planeacion: Planificacion[] = [];
  public filosofias: Filosofia_Corporativa[] = [];

  public idFilos: number = 0;
  public idPlanificacion: number;

  public filosofia: Filosofia_Corporativa; //para el edit
  public modalAgregar = false;
  public modalEditar = false;
  public viewTablero = false;
  public skeletons = ['','','']

  /** Grupo de validación de datos */
  formNuevo = new FormGroup({
    inputName: new FormControl('', [Validators.required]),
    inputDescription: new FormControl('', [Validators.required]),
  }, { validators: this.nombreDuplicidad() });

  formEdit = new FormGroup({
    inputName: new FormControl('', [Validators.required]),
    inputDescription: new FormControl('', [Validators.required]),
  }, { validators: this.nombreDuplicidad() });

  private valueDefault = {
    inputName: '',
    inputDescription: ''
  };

  constructor(
    public dataService: DataService,
    // private filosofiaService: FilosofiaCorporativaService,
    private excelService: ExcelService,
    private cookies: CookieService,
    private translate: TranslateService,

    private planificacionService: PlanificacionService,
    private filosofiaService: FilosofiaService,
  ) {
    this.obtData();
  }

  ngOnInit(): void { }

  /** Obtención de los datos */
  public async obtData() {
    try {
      //obtener el valor de las cookies
      const planeacionId = this.cookies.get('idInstitucion');
      const plan = await this.planificacionService.getPlanificacionByIdGQL(Number(planeacionId)); 
      this.idPlanificacion = parseInt(plan.id, 10); //conversion a number

      if (!plan) {
        return;
      }

      this.planeacion = [{
        id: plan.id,
        nombre: plan.name,
        fecha_inicio: moment(plan.initial_date).toDate(),
        fecha_fin: moment(plan.end_date).toDate(),
        institucionId: plan.institution.id,
        isActive: plan.isActive
      }];

      const filosofias = await firstValueFrom(this.filosofiaService.getFilosofia());
      this.obtFilosofia(filosofias);
      this.viewTablero = true;

    } catch (error) {
    }

  }

  private async obtFilosofia(response: any) {
    this.filosofias = [];
    for (const per of response) {
      if (Number(per.planning.id) === this.idPlanificacion) {
        this.filosofias.push({
          name: per.name,
          description: per.description,
          planningId: per.planning.id,
          id: per.id
        });
      }
    }

    if (this.filosofias.length === 0) {
      //crear misión, visión, principios
      var conceptodef1 = new Filosofia_Corporativa();
      var conceptodef2 = new Filosofia_Corporativa();
      var conceptodef3 = new Filosofia_Corporativa();

      conceptodef1.planningId = this.idPlanificacion;
      conceptodef1.name = 'Misión';
      conceptodef1.description = 'Misión';

      conceptodef2.planningId = this.idPlanificacion;
      conceptodef2.name = 'Visión';
      conceptodef2.description = 'Visión';

      conceptodef3.planningId = this.idPlanificacion;
      conceptodef3.name = 'Principios';
      conceptodef3.description = 'Principios';

      try {

        await firstValueFrom(this.filosofiaService.postfilosofia(conceptodef1));
        await firstValueFrom(this.filosofiaService.postfilosofia(conceptodef2));
        await firstValueFrom(this.filosofiaService.postfilosofia(conceptodef3));

        const responseFilosofia = await firstValueFrom(this.filosofiaService.getFilosofia());

        this.filosofias = [];

        for (const fil of responseFilosofia) {
          if ((Number(fil.planning.id) === this.idPlanificacion)) {
            this.filosofias.push({
              name: fil.name,
              description: fil.description,
              planningId: fil.planningId,
              id: fil.id
            });
          }
        }

      } catch (err) {
        let er = obtenerError.errorObt(err['error'].message);
        messages.errorMessageGraph(er);
      }
    }
    this.filosofias = this.ordenarConceptos(this.filosofias);
  }

  private ordenarConceptos(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  private async refrescarFilosofias() {
    const response = await firstValueFrom(this.filosofiaService.getFilosofia());
    this.filosofias = response
      .filter(con => Number(con.planning.id) === this.idPlanificacion)
      .map(con => ({
        id: con.id,
        name: con.name,
        description: con.description,
        planningId: con.planningId,
      }));

    this.filosofias = this.ordenarConceptos(this.filosofias);
  }



  /** Almacenado de datos y recarga de estos */
  private async almacenarDatos() {
    if (this.formNuevo.invalid) return;

    try {
      const filosofia = new Filosofia_Corporativa;
      filosofia.name = document.getElementById('nombre')["value"];
      filosofia.description = document.getElementById('descripcion')["value"];
      filosofia.planningId = this.idPlanificacion;

      await firstValueFrom(this.filosofiaService.postfilosofia(filosofia));
      await this.refrescarFilosofias();

      messages.succesMessageGraph(this.translate.instant('gestion.formulacion.filosofiaCorporativa.infoAgregada'));
      this.cerrarForm()
    } catch (err) {
      let er = obtenerError.errorObt(err['error'].message);
      messages.errorMessageGraph(er);
    }
  }

  private async almacenarDatosEdit() {
    if (this.formEdit.invalid) return;

    try {
      this.filosofia.name = document.getElementById('nombreedit')["value"];
      this.filosofia.description = document.getElementById('descripcionedit')["value"];

      await firstValueFrom(this.filosofiaService.patchfilosofia(this.filosofia));
      await this.refrescarFilosofias();

      messages.succesMessageGraph(this.translate.instant('gestion.formulacion.filosofiaCorporativa.infoActualizada'));
      this.cerrarForm();
    } catch (err) {
      let er = obtenerError.errorObt(err['error'].message);
      messages.errorMessageGraph(er);
    }
  }


  /** Metodos de decición de guardado */
  public alertas(aler: any) {
    if (aler === 'editar') {
      this.almacenarDatosEdit();
    } else if (aler === 'guardar') {
      if (!this.nombreExiste()) {
          this.almacenarDatos();
      } else {
        Swal.fire({
          title: this.translate.instant('swal.nombreExiste'),
          text: '',
          icon: 'error',
          showConfirmButton: false,
          timer: this.dataService.time
        });
      }
    }
  }

  /** Eliminación de datos */
  public async eliminar(filos: any) {
    const el = await messages.confirmationSave(
      this.translate.instant('acciones.delete-item'),
      `<strong> ${filos.name} </strong> <br> ${this.translate.instant('acciones.continuar')}`,
      this.translate
    )
    if(el){
      try {
        await firstValueFrom(this.filosofiaService.deletefil(filos));
        await this.refrescarFilosofias();
        messages.succesMessageGraph(
          this.translate.instant('gestion.formulacion.filosofiaCorporativa.infoEliminada')
        );
      } catch (err) {
        let er = obtenerError.errorObt(err['error'].message);
        messages.errorMessageGraph(er);
      }
    }
  }

  /** Exportación de archivos */
  public exportar_excel() {
    const title = this.translate.instant('gestion.formulacion.filosofiaCorporativa.tituloExcel');
    const header = [
      this.translate.instant('gestion.formulacion.filosofiaCorporativa.formText1'), 
      this.translate.instant('gestion.formulacion.filosofiaCorporativa.formText6')
    ];
    let rows = [];
    let cols = [];
    for (var i = 0; i < this.filosofias.length; i++) {
      cols.push(this.filosofias[i].name);
      cols.push(this.filosofias[i].description);
      rows.push(cols);
      cols = [];
    }

    this.excelService.generateExcelFilosofiaCorp(title, header, rows, "Filosofia_corporativas");
  }

  /** Apertura de los modales */
  public abrirFormAgregar(filo: any) {
    this.modalAgregar = true;

    this.idFilos = filo.id;
    // document.getElementById('formularionuevo')!.style.display = 'block';
  }

  public abrirForm(filo: any) {
    this.filosofia = filo;
    this.idFilos = filo.id;
    this.modalEditar = true;
    this.formEdit.controls['inputName'].setValue(this.filosofia.name);
    this.formEdit.controls['inputDescription'].setValue(this.filosofia.description);

    // document.getElementById('formulario')!.style.display = 'block'
  }


  /** Cerrar modales */
  public cerrarForm() {
    this.modalAgregar = false;
    this.modalEditar = false;

    this.formNuevo.reset(this.valueDefault);
    this.formEdit.reset(this.valueDefault);
  }

  /** Comprobación de que el nombre no exista en la lista de conceptos*/
  public puede_guardar() {
    var concept = new Filosofia_Corporativa();
    concept.name = this.formNuevo.get('inputName')?.value;
    concept.description = this.formNuevo.get('inputDescription')?.value;
    if (concept.name != '' && concept.description != '' && !this.nombreExiste()) {
      return ''
    }
    return 'w3-disabled'
  }

  public puede_guardarEdit() {
    var concept = new Filosofia_Corporativa();
    concept.name = this.formEdit.get('inputName')?.value;
    concept.description = this.formEdit.get('inputDescription')?.value;
    if (concept.name != '' && concept.description != '' && !this.nombreExiste()) {
      return ''
    }
    return 'w3-disabled'
  }

  public clickFuera(event, modal){
    if (event.target === document.getElementById(modal)) {
      document.getElementById(modal).classList.add('moveShake');
      setTimeout(() => {
        document.getElementById(modal).classList.remove('moveShake');
      },600);
    }
  }

  private nombreDuplicidad(): ValidatorFn {
    return (fg: FormGroup) => {
      const nombre = fg.get('inputName')!.value?.toString().trim().toLowerCase();
      if (!nombre) return null;

      const existe = this.filosofias.some(fi => {
        const otro = fi.name.trim().toLowerCase();
        if (this.modalEditar) {
          return (otro === nombre && fi.id !== this.filosofia.id);
        } else {
          return otro === nombre;
        }
      });

      return existe ? { isValid: true } : null;
    };
  }

  public nombreExiste(): boolean {
    if (this.modalAgregar) {
      return this.formNuevo.hasError('isValid');
    } else if (this.modalEditar) {
      return this.formEdit.hasError('isValid');
    }
    return false;
  }

}
